export default "__VITE_ASSET__Cz90x8Fg__"